import React, { useEffect, useState } from 'react';
import LinkService from '../../system/LinkService';
import useApiCall from '../../system/useApiCall';
import StandardTable from '../../common/Component/StandardTable';
import { GridColumns, GridRowsProp } from '@mui/x-data-grid';
import SottTeamTO from '../TO/SottTeamTO';
import SottTeamDataDialog from './SottTeamDataDialog';
import DropdownTO from '../../common/TO/DropdownTO';
import { MenuItem, Select } from '@mui/material';
import { useSottEventDropdownData } from '../Helper/SottHelperHooks';

export default function SottTeamPage() {
  const [editRow, setEditRow] = useState<number | null>(null);
  const [openDataDialog, setOpenDataDialog] = useState<boolean>(false);
  const [saveCount, setSaveCount] = useState<number>(0);
  const [sottTeamList, setSottTeamList] = useState<SottTeamTO[]>([]);
  const [selectedSottEvent, setSelectedSottEvent] = useState<number>(-1);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const apiCall = useApiCall();
  const SottEventDropdownData = useSottEventDropdownData();

  useEffect(() => {
    if (SottEventDropdownData.length > 0) {
      getSottEventActiveId();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [SottEventDropdownData.length]);

  useEffect(() => {
    getSottTeamAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveCount, selectedSottEvent]);

  useEffect(() => {
    if (editRow === null && openDataDialog) {
      setOpenDataDialog(false);
    } else if (editRow !== null && !openDataDialog) {
      setOpenDataDialog(true);
    }
  }, [editRow, openDataDialog]);

  const getSottTeamAll = () => {
    if (selectedSottEvent > -1) {
      setIsLoading(true);
      apiCall.get(LinkService.sottTeamBySottEventId(selectedSottEvent)).then((data) => {
        if (data) {
          const list: SottTeamTO[] = data;
          setSottTeamList(list);
          setIsLoading(false);
        }
      });
    }
  };

  const getSottEventActiveId = () => {
    apiCall.get(LinkService.sottEventActiveId()).then((data) => {
      if (data) {
        const eventId: number = data;
        setSelectedSottEvent(eventId);
      }
    });
  };

  const deleteSottTeamData = (id: number) => {
    apiCall.delete(LinkService.sottTeamDelete(id), 'Datensatz gelöscht.').then((data) => {
      getSottTeamAll();
    });
  };

  const getEditData = () => {
    const sottTeamData = sottTeamList.find((item: SottTeamTO) => item.id === editRow);
    return sottTeamData;
  };

  const columns: GridColumns = [
    { field: 'id', headerName: 'Nr.', type: 'number', width: 40, editable: false },
    { field: 'name', headerName: 'Name', flex: 1, editable: true },
  ];

  const rows: GridRowsProp = [...sottTeamList];

  return (
    <div>
      <Select
        margin='dense'
        id='sottevent'
        label='SotT Event'
        variant='standard'
        value={selectedSottEvent}
        onChange={(e) => setSelectedSottEvent(e.target.value as number)}
      >
        <MenuItem key={'sottDropdown_please_choose'} value={-1}>
          Event auswählen
        </MenuItem>
        {SottEventDropdownData.map((dropdownItem: DropdownTO) => (
          <MenuItem key={'sottDropdown_' + dropdownItem.id} value={dropdownItem.id}>
            {dropdownItem.name}
          </MenuItem>
        ))}
      </Select>
      <SottTeamDataDialog
        openDialog={openDataDialog}
        setEditRow={setEditRow}
        editData={editRow ? getEditData() : undefined}
        saveCount={saveCount}
        setSaveCount={setSaveCount}
        sottEventDropdown={SottEventDropdownData}
        preselectedSottEvent={selectedSottEvent}
      />
      <StandardTable
        saveURL={LinkService.sottTeamPost()}
        editRowNumber={setEditRow}
        columns={columns}
        rows={rows}
        deleteFunction={deleteSottTeamData}
        isLoading={isLoading}
      />
    </div>
  );
}
